import React from "react";
import styles from "./ui.module.scss";
import { useEventStore } from "../../store";

const EventDescription = () => {
  const { eventData } = useEventStore();

  if (!eventData?.description) return null;

  return (
    <div className={styles.EventDescription}>
      <h4 className={styles.EventDescription_Title}>Описание мероприятия</h4>
      <div
        className={styles.EventDescription_Content}
        dangerouslySetInnerHTML={{ __html: eventData.description }}
      />
    </div>
  );
};

export default EventDescription;
